import { useLayoutEffect, useRef } from 'react';
import { useBrowseSession, useBrowsePosition } from '../../features/browse/useBrowseList';

export function useArtistPageMemory(ready) {
  const memory = useBrowseSession('artist');
  return useBrowsePosition({ ...memory, ready });
}
export function useArtistRailMemory(kind, count) {
  const { entry } = useBrowseSession('artist'),
    ref = useRef(null);
  useLayoutEffect(() => {
    const node = ref.current?.querySelector('.pp-shelf-track');
    if (!node || !entry.current()) return;
    node.scrollLeft = entry.artistRails?.[kind] || 0;
    const save = () => {
      if (entry.current()) (entry.artistRails ||= {})[kind] = node.scrollLeft;
    };
    node.addEventListener('scroll', save, { passive: true });
    return () => {
      node.removeEventListener('scroll', save);
      save();
    };
  }, [entry, kind, count]);
  return ref;
}
